import { App } from "antd";
import { useCallback } from "react";

import { useAsyncAction } from "@/hooks";
import { useAppDispatch } from "@/hooks/redux";
import { safeReset } from "@/store/actions";
import { updateOfflineStatus } from "@/store/slices/offline";
import { isOnline } from "@/utils/network/isOnline";

export const useResetApp = () => {
    const { notification } = App.useApp();

    const dispatch = useAppDispatch();

    const [handleReset, resetLoading] = useAsyncAction(
        useCallback(async () => {
            const online = await isOnline();

            if (!online) {
                dispatch(updateOfflineStatus(true));

                notification.error({
                    title: "Відсутня мережа, застосунок перейшов у режим офлайн",
                });
                return;
            }

            dispatch(safeReset());
        }, [notification, dispatch]),
    );

    return { handleReset, resetLoading };
};
